import { Grid, GridItem } from '@chakra-ui/react';
import { InputField } from 'app/components/Core';
import { AudioVersionSelection } from '../AudioVersionSelection';
import { useLabelV2VersionAudio } from './hooks';
import { AudioReleaseVersionSelection } from '../AudioReleaseVersionSelection';

export const LabelV2VersionAudioForm = ({
  form: {
    register,
    formState: { errors },
  },
  onSubmit,
  isSyncing,
  primaryAudio,
  audioData,
  disabledAudios,
  releaseVersion,
  primaryAudioDisabled,
  replaceAudioVersion,
  primaryAudioFetching,
  isAudioReplacing,
  versionTypesDDL,
  updateVersion,
  fallbackTextFieldToSnapshot,
}: ReturnType<typeof useLabelV2VersionAudio>) => {
  return (
    <form onSubmit={onSubmit}>
      <Grid templateColumns="repeat(4, 1fr)" gap={4} maxW="640" m="auto">
        <GridItem colSpan={{ base: 4 }}>
          <InputField
            {...register('versionTitle')}
            label="Sound Recording Title"
            isDisabled={isSyncing}
            onBlur={fallbackTextFieldToSnapshot('versionTitle')}
            isInvalid={Boolean(errors?.versionTitle)}
            errorMessage={errors?.versionTitle?.message}
          />
        </GridItem>
        <GridItem colSpan={{ base: 4, md: 2 }}>
          <AudioVersionSelection
            value={primaryAudio}
            audioData={audioData}
            disabledAudios={disabledAudios}
            songTitle={releaseVersion.metadata.songTitle}
            disabled={primaryAudioDisabled}
            onSelect={(audioGuid) => {
              if (audioGuid !== primaryAudio?.value) {
                replaceAudioVersion(audioGuid);
              }
            }}
            versionSongGuid={releaseVersion.song.songGuid}
            loading={primaryAudioFetching || isAudioReplacing}
          />
        </GridItem>
        <GridItem colSpan={{ base: 4, md: 2 }}>
          <AudioReleaseVersionSelection
            versionTypesDDL={versionTypesDDL}
            audioReleaseVersion={releaseVersion.metadata.type}
            onChange={(option) => {
              if (option?.value) {
                updateVersion({ type: option.value as string });
              }
            }}
          />
        </GridItem>
        <GridItem colSpan={2} display={{ base: 'none', md: 'block' }} />
      </Grid>
    </form>
  );
};
